module.exports = __webpack_public_path__ + "static/media/sent_messages.577df6ce.svg";